import styled from '@emotion/styled';
import { Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import { SCREEN_SIZE } from '../../../../constants';

const getComponentStyle =
  (path: string) =>
  ({ isBig, ...rest }: { isBig?: boolean }) =>
    themeGet(
      `components.collapsiblePackageSection.heading.${
        isBig ? 'big' : 'small'
      }.${path}`,
    )(rest);

const Heading = styled(Text)<{ isBig?: boolean }>`
  font-size: ${getComponentStyle('mobile.fontSize')};
  line-height: ${getComponentStyle('mobile.lineHeight')};
  font-weight: ${getComponentStyle('fontWeight')};
  font-family: ${getComponentStyle('fontFamily')};
  color: ${getComponentStyle('color')};

  ${SCREEN_SIZE.MD} {
    font-size: ${getComponentStyle('fontSize')};
    line-height: ${getComponentStyle('lineHeight')};
  }
`;

export default Heading;
